export const stripNonNumericalCharacters = (value: string): string => {
    const filterRegex = /[0-9]/;
    if (Number(value) || value === undefined) return value;
  
    return value
      .split('')
      .filter((c) => filterRegex.test(c))
      .join('');
  };